import { render, staticRenderFns } from "./AdminEditClient.vue?vue&type=template&id=639df3b0"
import script from "./AdminEditClient.vue?vue&type=script&lang=js"
export * from "./AdminEditClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports